import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

interface UseGridStickyFooterReturn {
    refFooter: (node?: Element | null) => void;
    isStickyGridButtons: boolean;
}

export const useGridStickyFooter = (): UseGridStickyFooterReturn => {
    const [isStickyGridButtons, setIsStickyGridButtons] = useState(false);

    const [refFooter, inView, entry] = useInView({
        /* Optional options */
        root: document.querySelector('#page-scroll-grid-sticky'),
        threshold: 0.1,
        initialInView: true,
    });

    useEffect(() => {
        setIsStickyGridButtons(
            !!(!inView && entry && entry.rootBounds && entry.rootBounds.top < entry?.boundingClientRect?.top),
        );
    }, [inView, entry]);

    return {
        refFooter,
        isStickyGridButtons,
    };
};
